import {Element} from "@api/models/Element";
import {Meeting} from "@api/models/meetings/Meeting";
import {DateTime} from "luxon";

/**
 * Checks if sessions has stopped already
 * @param element
 */
export const sessionHasStopped = (element: Element | Meeting) => {
    if (element instanceof Element) {
        return element.isStarted && element.isClosed;
    }

    return false;
}

/**
 * Checks if session has started
 * @param element
 */
export const sessionStarted = (element: Element | Meeting): boolean => {
    if (element instanceof Element) {
        if (Object.prototype.hasOwnProperty.call(element, 'isStarted')) {
            return element.isStarted;
        }
        if (Object.prototype.hasOwnProperty.call(element, 'isOnline')) {
            return element.isOnline;
        }
        return false;
    }

    return Boolean(element.beginAt && DateTime.local() >= element.beginAt);
}